module.exports = __webpack_public_path__ + "12ca542c389a5df328ce9afbe82c6781.pdf";